import { useEffect } from "react";
import { useTheme, styled, Box, IconButton } from "@mui/material";
import { CompressRounded, ExpandRounded } from "@mui/icons-material";
import { useEffectExceptOnMount } from "../../../../hooks";

const RoundedIconButton = styled(IconButton)(() => ({
  borderRadius: "4px",
  cursor: "pointer",
}));

const EXPAND_ROWS_KEY = "expand-rows";
const EXPAND_ROWS_REDIRECTS_KEY = "expand-rows-redirects";

const ExpansionToggle = ({
  isExpanded,
  setExpansion,
  forRedirects = false,
}) => {
  const theme = useTheme();

  const expandRowsKey = forRedirects
    ? EXPAND_ROWS_REDIRECTS_KEY
    : EXPAND_ROWS_KEY;

  useEffect(() => {
    const expand_rows = localStorage.getItem(expandRowsKey);
    if (expand_rows === null) {
      localStorage.setItem(expandRowsKey, JSON.stringify(isExpanded)); // Always save as stringified boolean
      return;
    }
    const parsedValue = expand_rows === "true"; // convert string to boolean
    if (parsedValue !== isExpanded) {
      setExpansion(parsedValue);
    }
  }, []);

  useEffectExceptOnMount(() => {
    localStorage.setItem(expandRowsKey, JSON.stringify(isExpanded));
  }, [isExpanded]);

  return (
    <Box sx={{ display: "flex" }}>
      <RoundedIconButton
        onClick={() => setExpansion(true)}
        sx={{
          px: 1.5,
          borderRadius: 2,
          borderStartEndRadius: 0,
          borderEndEndRadius: 0,
          border: theme.palette.tinyBorder,
          backgroundColor: isExpanded && theme.palette.action.hover,
        }}
      >
        <ExpandRounded fontSize="small" />
      </RoundedIconButton>
      <RoundedIconButton
        onClick={() => setExpansion(false)}
        sx={{
          px: 1.5,
          borderRadius: 2,
          borderEndStartRadius: 0,
          borderStartStartRadius: 0,
          borderTop: theme.palette.tinyBorder,
          borderRight: theme.palette.tinyBorder,
          borderBottom: theme.palette.tinyBorder,
          backgroundColor: !isExpanded && theme.palette.action.hover,
        }}
      >
        <CompressRounded fontSize="small" />
      </RoundedIconButton>
    </Box>
  );
};

export default ExpansionToggle;
